export * from './seguimento-edit.component';
export * from './seguimento-browse.component';